export const QUERY_KEYS = {
  INVOICES: 'invoices',
  ORDER_SESSIONS: 'orderSessions',
  STORE_AREAS: 'storeAreas',
};
